import isEmpty from "lodash/isEmpty";
import { cleanPhoneNumberFormat } from "@spike/phone-utils";
export var isPhoneNumberValid = function (phoneNumber, countryId) {
    if (["US", "CA"].includes(countryId.toUpperCase())) {
        return (cleanPhoneNumberFormat(phoneNumber).length === 10);
    }
    else {
        return /\+{0,1}[0-9]{4,12}/.test(phoneNumber);
    }
};
export var validatePhoneNumber = function (phoneNumber, countryId, fieldName) {
    if (!isPhoneNumberValid(phoneNumber, countryId)) {
        return [{ fieldName: fieldName !== null && fieldName !== void 0 ? fieldName : "phoneNumber", errorMessage: countryId.toUpperCase() === "US" ? "Phone number format must be (NNN) NNN-NNNN" : "Phone number length 4-12 digits." }];
    }
    else {
        return [];
    }
};
export var isEmailValid = function (email) {
    // eslint-disable-next-line no-useless-escape
    var regExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
    return (email !== undefined && email !== null && email.match(regExp) !== null);
};
export var isWebsiteValid = function (website) {
    // eslint-disable-next-line no-useless-escape
    var regExp = /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
    return (website && website.match(regExp) !== null);
};
export var validateZipcode = function (zipcode, countryId, fieldName) {
    var errors = [];
    if ((countryId === null || countryId === void 0 ? void 0 : countryId.toUpperCase()) === "US") {
        if (!/[0-9]{5}/.test(zipcode)) {
            errors.push({ fieldName: fieldName !== null && fieldName !== void 0 ? fieldName : "zipcode", errorMessage: "Zipcode must be 5 digits." });
        }
    }
    else if ((countryId === null || countryId === void 0 ? void 0 : countryId.toUpperCase()) === "CA") {
        if (!/[A-Z][0-9][A-Z] [0-9][A-Z][0-9]/.test(zipcode) && !/[A-Z][0-9][A-Z][0-9][A-Z][0-9]/.test(zipcode)) {
            errors.push({ fieldName: fieldName !== null && fieldName !== void 0 ? fieldName : "zipcode", errorMessage: "Zipcode format must be A#A #A# or A#A#A#." });
        }
    }
    else {
        if (zipcode.length > 10) {
            errors.push({ fieldName: fieldName !== null && fieldName !== void 0 ? fieldName : "zipcode", errorMessage: "Zipcode maximum length is 10." });
        }
        if (!/([A-Z]|[0-9]){0,10}/.test(zipcode)) {
            errors.push({ fieldName: fieldName !== null && fieldName !== void 0 ? fieldName : "zipcode", errorMessage: "Zipcode must be alfanumeric without spaces." });
        }
    }
    return errors;
};
export var validateAddress = function (address) {
    var _a;
    var errors = [];
    if (!isEmpty(address === null || address === void 0 ? void 0 : address.street) || !isEmpty(address === null || address === void 0 ? void 0 : address.city) || !isEmpty(address === null || address === void 0 ? void 0 : address.state) || !isEmpty(address === null || address === void 0 ? void 0 : address.zipcode)) {
        if (isEmpty(address === null || address === void 0 ? void 0 : address.street)) {
            errors.push({ fieldName: "address.street", errorMessage: "Street is required." });
        }
        if (isEmpty(address === null || address === void 0 ? void 0 : address.city)) {
            errors.push({ fieldName: "address.city", errorMessage: "City is required." });
        }
        if (isEmpty(address === null || address === void 0 ? void 0 : address.state)) {
            errors.push({ fieldName: "address.state", errorMessage: "State is required." });
        }
        if (isEmpty(address === null || address === void 0 ? void 0 : address.zipcode)) {
            errors.push({ fieldName: "address.zipcode", errorMessage: "Zipcode is required." });
        }
        if (!isEmpty(address === null || address === void 0 ? void 0 : address.zipcode)) {
            errors.push.apply(errors, validateZipcode(address.zipcode, (_a = address.country) === null || _a === void 0 ? void 0 : _a.id, "address.zipcode"));
        }
    }
    return errors;
};
export var validatePassword = function (password) {
    var errors = [];
    if (isEmpty(password) || (password === null || password === void 0 ? void 0 : password.length) < 7) {
        errors.push({ fieldName: "password", errorMessage: "Password minimun length is seven." });
    }
    if (!isEmpty(password) && !password.match(/\d/g)) {
        errors.push({ fieldName: "password", errorMessage: "Password must have at lease one numeric character." });
    }
    if (!isEmpty(password) && !password.match(/[a-z|A-Z]/)) {
        errors.push({ fieldName: "password", errorMessage: "Password must have at lease one character." });
    }
    return errors;
};
